import {PureComponent, Fragment} from 'react'
import PropTypes from 'prop-types'

import ArticleCard from './ArticleCard/ArticleCard.jsx'
import EoCarousel from '../EoCarousel/EoCarousel.jsx'

import './ArticlesList.scss'

export default class ArticlesList extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    articles: PropTypes.array,
    card: PropTypes.func,
    flex: PropTypes.bool.isRequired
  }

  static defaultProps = {
    className: '',
    articles: [],
    card: ArticleCard,
  }

  render() {
    const Card = this.props.card
    const articles = this.props.articles.map((article, index) => <Card article={article} key={article.id || index}/>)

    return (
      <Fragment>
        {this.props.children}
        {this.props.articles.length > 0 ?
          <Fragment>
            <ul className={`articles-list ${this.props.className} d-none d-md-${this.props.flex ? 'flex' : 'block'}`}>
              {articles}
            </ul>
            <ul className={`articles-list d-${this.props.flex ? 'flex flex-column' : 'block'} d-md-none`}>
              <EoCarousel loop={false}>
                {articles}
              </EoCarousel>
            </ul>
          </Fragment>
          :
          <p className={this.props.className}>Aucun article publié</p>
        }
      </Fragment>
    )
  }
}